import moment from 'moment'
import { createSelector } from 'reselect'

import { RootState } from '@/store'

const getAuthentication = (state: RootState) => state.authentication

export const isAuthenticated = createSelector(getAuthentication, ({ isAuthenticated }) => !!isAuthenticated)

export const isAuthenticationError = createSelector(
  getAuthentication,
  ({ isAuthenticationError }) => !!isAuthenticationError
)

export const getAccessToken = createSelector(getAuthentication, ({ accessToken }) => accessToken)

export const getCurrentUserEmail = createSelector(getAuthentication, ({ email }) =>
  email ? email.toLowerCase() : null
)

export const getSessionExpirationMoment = createSelector(getAuthentication, ({ expirationTime }) =>
  expirationTime ? moment(expirationTime * 1000) : null
)
